module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-info jin-rili_rate"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jin-info_b",
    class: {
      'hide-border': !_vm.border
    }
  }, [_c('div', {
    staticClass: "jin-rili_rate-wrap"
  }, [_c('table', {
    staticClass: "jin-table_body"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rates), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('img', {
      attrs: {
        "width": "24",
        "height": "16",
        "src": item.flagImgUrl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.bankName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.interestRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.publishTime))])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-info_title"
  }, [_c('h5', [_c('i', {
    staticClass: "ushk-icon ushk-icon_zhexiantu"
  }), _vm._v(" "), _c('span', [_vm._v("各国/地区央行利率")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('b', [_vm._v("央 行")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("利 率")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("发布日期")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d209be","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rate.vue
// module id = Vx3l
// module chunks = 2